<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        
        <v-card class="card-foto">
          <v-card-title class="deep-purple">
            <div class="white--text headline">Foto Criança</div>
          </v-card-title>
          <v-card-text class="card-foto-text">
            <v-card class="card-foto-img" hover>
              <input type="file" @change="setImage('Crianca', $event)" accept="image/*" class="input-file">

              <template v-if="fotos.fotoCrianca">
                <img :src="fotos.fotoCrianca" alt="">
                <v-btn fab dark @click="deleteImage('Crianca')" class="delete-photo">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </template>
              <template v-else>
                <div class="foto-place">
                  <v-icon class="add-photo">add_a_photo</v-icon>
                  <h3>Enviar Foto</h3>
                </div>
              </template>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card class="card-foto">
          <v-card-title class="deep-purple">
            <div class="white--text headline">Foto Família</div>
          </v-card-title>
          <v-card-text class="card-foto-text">
            <v-card class="card-foto-img" hover>
              <input type="file" @change="setImage('Familia', $event)" accept="image/*" class="input-file">

              <template v-if="fotos.fotoFamilia">
                <img :src="fotos.fotoFamilia" alt="" class="elevation-4">
                <v-btn fab dark @click="deleteImage('Familia')" class="delete-photo">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </template>
              <template v-else>
                <div class="foto-place">
                  <v-icon class="add-photo">add_a_photo</v-icon>
                  <h3>Enviar Foto</h3>
                </div>
              </template>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
    <v-layout row wrap>

      <v-flex xs12>
        <v-card class="card-foto">
          <v-card-title class="deep-purple">
            <div class="white--text headline">Fotos Mural</div>
          </v-card-title>

            <v-layout row wrap>
              <v-flex xs12 sm6 class="mural-img">
                <v-card class="card-foto-img" hover>
                  <input type="file" @change="setImage('Mural1', $event)" accept="image/*" class="input-file">
                  <template v-if="fotos.fotoMural1">
                    <img :src="fotos.fotoMural1" alt="" class="elevation-4">
                    <v-btn fab dark @click="deleteImage('Mural1')" class="delete-photo">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="foto-place">
                      <v-icon class="add-photo">add_a_photo</v-icon>
                      <h3>Enviar Foto</h3>
                    </div>
                  </template>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="mural-img">
                <v-card class="card-foto-img" hover>
                  <input type="file" @change="setImage('Mural2', $event)" accept="image/*" class="input-file">
                  <template v-if="fotos.fotoMural2">
                    <img :src="fotos.fotoMural2" alt="" class="elevation-4">
                    <v-btn fab dark @click="deleteImage('Mural2')" class="delete-photo">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="foto-place">
                      <v-icon class="add-photo">add_a_photo</v-icon>
                      <h3>Enviar Foto</h3>
                    </div>
                  </template>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="mural-img">
                <v-card class="card-foto-img" hover>
                  <input type="file" @change="setImage('Mural3', $event)" accept="image/*" class="input-file">
                  <template v-if="fotos.fotoMural3">
                    <img :src="fotos.fotoMural3" alt="" class="elevation-4">
                    <v-btn fab dark @click="deleteImage('Mural3')" class="delete-photo">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="foto-place">
                      <v-icon class="add-photo">add_a_photo</v-icon>
                      <h3>Enviar Foto</h3>
                    </div>
                  </template>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="mural-img">
                <v-card class="card-foto-img" hover>
                  <input type="file" @change="setImage('Mural4', $event)" accept="image/*" class="input-file">
                  <template v-if="fotos.fotoMural4">
                    <img :src="fotos.fotoMural4" alt="" class="elevation-4">
                    <v-btn fab dark @click="deleteImage('Mural4')" class="delete-photo">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="foto-place">
                      <v-icon class="add-photo">add_a_photo</v-icon>
                      <h3>Enviar Foto</h3>
                    </div>
                  </template>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="mural-img">
                <v-card class="card-foto-img" hover>
                  <input type="file" @change="setImage('Mural5', $event)" accept="image/*" class="input-file">
                  <template v-if="fotos.fotoMural5">
                    <img :src="fotos.fotoMural5" alt="" class="elevation-4">
                    <v-btn fab dark @click="deleteImage('Mural5')" class="delete-photo">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="foto-place">
                      <v-icon class="add-photo">add_a_photo</v-icon>
                      <h3>Enviar Foto</h3>
                    </div>
                  </template>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 class="mural-img">
                <v-card class="card-foto-img" hover>
                  <input type="file" @change="setImage('Mural6', $event)" accept="image/*" class="input-file">
                  <template v-if="fotos.fotoMural6">
                    <img :src="fotos.fotoMural6" alt="" class="elevation-4">
                    <v-btn fab dark @click="deleteImage('Mural6')" class="delete-photo">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <div class="foto-place">
                      <v-icon class="add-photo">add_a_photo</v-icon>
                      <h3>Enviar Foto</h3>
                    </div>
                  </template>
                </v-card>
              </v-flex>

            </v-layout>

        </v-card>
      </v-flex>


      <div class="objurl-div" v-show="toCrop">
        <div class="image-actions" v-show="!loading">
          <v-btn fab dark @click="toCrop = false">
            <v-icon dark>arrow_back</v-icon>
          </v-btn>
          <v-btn fab dark @click="rotate(-90)">
            <v-icon dark>rotate_left</v-icon>
          </v-btn>
        </div>

        <v-progress-circular v-bind:size="160" v-bind:width="20" v-bind:rotate="360" v-bind:value="progress" class="white--text progress" v-show="loading">
          {{ progress }}
        </v-progress-circular>
        <img :src="cropImg" class="imgPreview" v-show="loading">

        <div class="crop-container" v-show="!loading">
          <vue-cropper ref="cropper" :guides="true" :view-mode="2" drag-mode="none" :auto-crop-area="1" :movable="true" :background="true" :rotatable="true" :scalable="false" :zoomOnTouch="false" :checkOrientation="true" :img-style="{ 'height':'420px' }">
          </vue-cropper>
        </div>

        <v-btn fab dark class="purple btn-send-foto" @click.native="cropImage()" v-show="!loading">
          <v-icon dark>send</v-icon>
        </v-btn>
      </div>



    </v-layout>
  </v-container>
</template>

<script>
import VueCropper from "vue-cropperjs";
import dataURLtoBlob from "blueimp-canvas-to-blob";

export default {
  components: {
    "vue-cropper": VueCropper
  },
  data() {
    return {
      active: false,
      usuario: {},
      fotos: {},
      toCrop: false,
      loading: false,
      progress: 0,
      cropImg: "",
      photoType: "",
      emailkey: "",
      projeto: ""
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.emailkey = user.email.replace(/[.]/g, ",");
        const ref = this.$db.ref(`users/${this.emailkey}`);
        ref.once("value", snap => {
          this.projeto = snap.val().projeto.atual;
          this.$bindAsObject(
            "fotos",
            ref.child(`projeto/projetos/${this.projeto}/dados/fotos`)
          );
        });
      } else {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    deleteImage(photoType) {
      const confirmar = confirm("DELETAR FOTO - Tem certeza?");
      if (confirmar === true) {
        const storageRef = this.$storage.ref(
          `users/${this.emailkey}/foto${photoType}.jpg`
        );
        storageRef
          .delete()
          .then(() => {
            let updates = {};
            updates[
              `users/${this.emailkey}/projeto/projetos/${
                this.projeto
              }/dados/fotos/foto${photoType}`
            ] = null;
            updates[
              `projetos/${this.projeto}/formandos/${
                this.emailkey
              }/fotos/foto${photoType}`
            ] = null;
            this.$db.ref().update(updates);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    setImage(photoType, e) {
      const file = e.target.files[0];
      this.photoType = photoType;

      if (!file.type.includes("image/")) {
        alert("Selecione uma imagem");
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = e => {
          this.toCrop = true;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(e.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Desculpa, atualize o navegador para continuar");
      }
    },
    cropImage() {
      const vm = this;
      const photoType = this.photoType;
      const emailkey = this.emailkey;
      const projeto = this.projeto;
      const db = this.$db.ref();
      vm.loading = true;
      vm.cropImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg");
      const blobImg = dataURLtoBlob(vm.cropImg);
      const storageRef = this.$storage.ref(
        `users/${this.emailkey}/foto${photoType}.jpg`
      );
      const task = storageRef.put(blobImg);
      task.on(
        "state_changed",
        function progress(snapshot) {
          let percentage =
            snapshot.bytesTransferred / snapshot.totalBytes * 100;
          vm.progress = parseInt(percentage);
        },
        function error(err) {
          console.error("Upload failed:", err);
        },
        function complete(snapshot) {
          var downloadURL = task.snapshot.downloadURL;
          let updates = {};
          updates[
            `users/${emailkey}/projeto/projetos/${projeto}/dados/fotos/foto${photoType}`
          ] = downloadURL;
          updates[
            `projetos/${projeto}/formandos/${emailkey}/fotos/foto${photoType}`
          ] = downloadURL;
          db.update(updates);
          vm.toCrop = false;
          vm.loading = false;
        }
      );
    },
    rotate(angle) {
      this.$refs.cropper.rotate(angle);
    }
  }
};
</script>

<style lang="stylus">

.input-file
  opacity: 0
  width: 100%
  height: 100%
  top: 0
  bottom: 0
  left: 0
  right: 0
  position: absolute
  cursor: pointer
  z-index: 1

.foto-place
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  width: 250px
  height: 200px
  background-color: #939393
  .icon
    font-size: 100px
    margin-top: 30px
  h3
    font-size: 20px
    font-weight: 700
    color: #ffffff

.card-foto-text
  display: flex
  align-items: center
  justify-content: center
  height: 300px
  .card-foto-img
    display: flex
    align-items: center
    justify-content: center
    background-color: #a8a8a8
    img
      display: block
      max-width:100%
      max-height:280px

.card-foto-img
  &:hover .delete-photo
    opacity: 1
    transform: scale(1);
  .delete-photo
    transform: scale(0.1)
    opacity: 0
    transition: all .1s linear
    position: absolute
    bottom: -15px
    right: -15px
    border-radius: 50% !important
    z-index: 3

.mural-img
  position: relative
  display: flex
  align-items: center
  justify-content: center
  height: 220px
  img
    display: block
    max-width:100%
    max-height:200px

.objurl-div
  display: flex
  align-items: center
  justify-content: center
  position: fixed
  top: 0
  left: 0
  bottom: 0
  width: 100%
  height: auto
  background-color: #000
  z-index: 10
  .image-actions
    width: 100%
    position: absolute
    top: 0
    left: 0
    display: flex
    height: 60px
    justify-content: center
    padding-top: 10px
    z-index: 10
  .imgPreview
    display: block
    max-height: calc(90% - 80px)
    max-width: 90%
    margin: 0px auto
    z-index: 10
  .crop-container
    display: block
    max-height: calc(90% - 80px)
    max-width: 90%
    margin: 50px auto
    background-color: #000
    .cropper-bg
      background-repeat: repeat
  .btn-send-foto
    position: absolute
    right: 30px
    bottom: 30px
    height: 60px
    width: 60px
    transition: all 0.5s linear
    &.sending
      right: calc(50% - 80px)
      bottom: calc(50% - 80px)
      opacity: 0
      height: 160px
      width: 160px
  .progress
    position: absolute
    left: calc(50% - 80px)
    top: calc(50% - 80px)
    z-index: 12
  .progress-circular__info
    font-size: 32px

</style>



// WEBPACK FOOTER //
// src/views/AppMainFotos.vue